import { render, staticRenderFns } from "./localDynamics.vue?vue&type=template&id=1c647344&scoped=true"
import script from "./localDynamics.vue?vue&type=script&lang=js"
export * from "./localDynamics.vue?vue&type=script&lang=js"
import style0 from "./localDynamics.vue?vue&type=style&index=0&id=1c647344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c647344",
  null
  
)

export default component.exports